import React, { Component } from 'react';
import InputBox from '../components/InputBox';
import ShowResult from '../components/ShowResult';
import Button from '../components/Button';
import 'tachyons';
import love_svg from './made_with_love.svg';
import './App.css';


class App extends Component {
	constructor(){
		super()
		this.state = {
			'fname': '',
			'sname': '',
			'rfname': '',
			'rsname': '',
			'result': '',
			'message': '',
			'isLoaded': ''
		}
	}

	onInputChange = (event, name) => {
		this.setState({[name]: event.target.value});
	}

	test = (event) => {
		this.setState({'isLoaded': 'none'})
		let url = `https://love-calculator.p.rapidapi.com/getPercentage?fname=${this.state.fname}&sname=${this.state.sname}`;
		fetch(url, {
			"method": "GET",
			"headers": {
				"x-rapidapi-key": "82218d1bc9msh252b777237daea7p11b255jsna2718e2791d9",
				"x-rapidapi-host": "love-calculator.p.rapidapi.com"
			}
		})
		.then(response => {
			return response.json();
		}).then(resjson=>{
			this.setState({'rfname': resjson.fname, 'rsname': resjson.sname, 'result': resjson.percentage, 'message': resjson.result, 'isLoaded': 'yes'})
			let query_url = `https://zubalovetester.herokuapp.com/insert.php?fname=${resjson.fname}&sname=${resjson.sname}&result=${resjson.percentage}`
			fetch(query_url, {
				"method": "GET"
			}).then(response => {
				return response.json()
			}).then(dat => {
				console.log(dat.success)
			})
		});
	}

	render(){
		return(
			<div>
				<p className="contributer">Made with <img className="love_svg" alt="love" src={love_svg}></img> by Zubayer Rahaman</p>
				<div className='tc'>
					<h1 className="tc">Love Tester</h1>
					<InputBox name='fname' inputChange={this.onInputChange} placeholder="Enter Your Name" />
					<InputBox name='sname' inputChange={this.onInputChange} placeholder="Enter Your GF/BF Name" />
					<Button test={this.test} />
					<ShowResult
					fname={this.state.rfname}
					sname={this.state.rsname}
					result={this.state.result}
					message={this.state.message}
					isLoaded={this.state.isLoaded}
					/>
				</div>
			</div>
		);
	}
}

// hostinger pass Tskms6mswIUYRfmte^M%

export default App;